import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {DatosAdicionalesDTO, DatosObservatorioDto, ParametrizacionRequestDto} from '../../../dto/empresa/empresa.dto';


@Injectable({
  providedIn: 'root'
})
export class EmpresaService {
  private apiUrl = `${environment.apiUrl}/creacion-empresa`;
  private apiUrlAuth = `${environment.apiUrl}/autenticacion-empresa`;

  constructor(
    private http: HttpClient
  ) { }

  crearSolicitudEmpresa(formData: FormData) {
    return this.http.post(`${this.apiUrl}/solicitud`, formData);
  }

  parametrizacionPasosEmpresa(body: ParametrizacionRequestDto) {
    return this.http.post(`${this.apiUrl}/parametrizacion`, body);
  }

  saveUsuario(idSolicitud: number, body: any) {
    return this.http.post(`${this.apiUrl}/asociar-usuario/${idSolicitud}`, body);
  }

  autenticacionEmpresa(body: {
    username: string,
    contrasena: string
  }) {
    return this.http.post(`${this.apiUrlAuth}/login`, body);
  }

  restablecerPasswordEmail(body: {
    email: string
  }) {
    return this.http.post(`${this.apiUrlAuth}/restablecer-contrasena-email`, body);
  }

  restablecerPassword(idUsuario: number, body: {
    contrasenaNueva: string,
    confirmarNuevaContrasena: string,
  }) {
    return this.http.post(`${this.apiUrlAuth}/restablecer-contrasena/${idUsuario}`, body);
  }

  notificacion(idSolicitud: number, aceptado: boolean) {
    return this.http.get(`${this.apiUrl}/notificacion/${idSolicitud}?aceptado=${aceptado}`);
  }

  saveDatosAdicionales(body: DatosObservatorioDto) {
    return this.http.post(`${this.apiUrl}/datos-adicionales`, body);
  }

  cargarDatosAdicionales(idPersona: number) {
    return this.http.get<DatosAdicionalesDTO>(`${this.apiUrl}/datos-adicionales-persona/${idPersona}`);
  }
}
